<template>
  <div >
    <form-header :pageTitle="'系统角色权限设置'" @save="save('ruleForm')" style="margin: 0 20px;"></form-header>
    <div class="white-bg-radius role-setting w-label">
      <!--<el-row>-->
        <!--<el-col :span="8">-->
          <div class="left-menu" :class="isFirefox? 'isFirefox' : '' ">
            <SearchCheckTree
              ref="menuTree"
              :placeholderSearchText="'菜单名称搜索'"
              :dialog-visible="true"
              :data="menuData"
              :defaultCheckedKeys="defaultMenuCheckedKeys"
              :default-props="defaultMenuProps"
              :defaultExpandAll="true"
            ></SearchCheckTree>
          </div>
        <!--</el-col>-->
        <!--<el-col :span="16">-->
          <div class="right-form report-params-inForm">
              <el-form :model="ruleForm" :rules="rules" ref="form"
                       label-position="right" label-width="100px" class="demo-ruleForm">
                <p class="title">角色信息</p>
                <el-form-item label="角色编码：" prop="roleCode">
                  <el-input v-model="ruleForm.roleCode" :disabled="disabled" placeholder="请输入角色编码"></el-input>
                </el-form-item>
                <el-form-item label="角色名称：" prop="roleName">
                  <el-input v-model="ruleForm.roleName" placeholder="请输入角色名称"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                  <el-input v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="state">
                  <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="0">有效</el-radio>
                    <el-radio :label="1">无效</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-if="false">
                <p class="sub-title">数据权限</p>
                <el-form-item label="全局数据权限：" prop="permissionType">
                  <!--<el-select v-model="ruleForm.region" placeholder="请选择权限" @change="permissionChange">-->
                    <!--<el-option v-for=" (p,index) in permissionTypes" :key="index"  :value="p.value" >{{p.label}}</el-option>-->
                  <!--</el-select>-->
                  <el-button type="primary" size="mini" @click="permissionChange">请选择组织</el-button>

                </el-form-item>
                <div>
                  <SearchCheckTree
                    :placeholderSearchText="'组织名称搜索'"
                    :dialog-visible="showDialogFlag"
                    :data="organizeData"
                    showCheckAll
                    :defaultCheckedKeys="defaultOrganizeKeys"
                    :default-props="defaultOrganizeProps"
                  ></SearchCheckTree>
                </div>
                </div>

              </el-form>
          </div>
        <!--</el-col>-->
      <!--</el-row>-->

    </div>
  </div>
</template>
<script>
  // import { mapGetters } from 'vuex'
  import formHeader from '../components/form-header'

  import commonMixin from '@/mixins/common.js'
  import SearchCheckTree from "../components/search-check-tree.vue";
  import { methodPost, methodGet } from '@/api/requestWithMessage'
  const menuUrl = '/sysmenu/findSysMenuTreeList'
  const organizeUrl = '2'
  const getInfoByIdUrl = '/role/get/'
  const submitUrl = '/role/saveSysRole'
  const modifyUrl = '/role/modifySysRole'
  export default {
    name: 'index',
    mixins: [commonMixin],
    data() {
      return {
        isFirefox: false,
        id: this.$route.query.id,
        permissionTypes: [
          { label: '仅自己', value: '仅自己' },
          { label: '自己及以下', value: '自己及以下' },
          { label: '同级及以下', value: '同级及以下' },
          { label: '全部', value: '全部' },
          { label: '自定义', value: '自定义' }
        ],
        organizeData: [],
        menuData: [],
        ruleForm: {
          roleCode: '',
          roleName: '',
          status: 0,
          dataPermission: [],
          permissionType: ''
        },
        rules: {
          roleCode: [{ required: true, message: "此项为必填项" }],
          roleName: [{ required: true, message: "此项为必填项" }],
          status: [{ required: true, message: "此项为必填项" }]
        },
        showDialogFlag: true,
        defaultMenuCheckedKeys: [],
        defaultOrganizeKeys: [],
        defaultMenuProps: {
          children: 'children',
          label: 'menuName',
          id: 'id'
        },
        value15: "",
        defaultOrganizeProps: {
          children: 'children',
          label: 'label',
          id: 'id'
        }
      }
    },
    components: {
      SearchCheckTree,
      formHeader
    },
    computed: {
      disabled() {
        return !!this.id
      }
    },
    methods: {
      permissionChange(val) {
        console.log(val)
        // if (val === '自定义') {
        this.showDialog()
        // } else {
        //   this.showDialogFlag = false
        // }
      },
      back(isRefresh) {
        const path = '/config/%2Ftemplate%2Fmodule%2Fsystem%2Fsystem_role_list.json'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$bus.$emit('refresh-grid')
          })
        }
      },
      save() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        const param = this.ruleForm
        const url = this.id ? modifyUrl : submitUrl;
        if (this.id) {
          param['id'] = this.id
        }
        param['menuIds'] = this.$refs.menuTree.getCheckedKeys()
        methodPost(url, param).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.back(1)
          } else {
            this.$message.error(res.message || '出错了！')
          }
        }).catch(err => {
          console.error(err)
          this.$message.error(err.message || '出错了！')
        })
      },
      getMenuData() {
        methodPost(menuUrl).then(res => {
          this.menuData = res.data
        })
      },
      getOrganizeData() {
        methodPost(organizeUrl).then(res => {
          this.organizeData = res.data
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      // 选中SAP开单送达方：
      getSelectItem1(item) {
        // 开单客户代号
        this.ruleForm.sysSapSendCode = item.kunnr
        this.ruleForm.sysSapSendCodeName = item.kunnr + '  ' + item.name
      },
      // 出现弹框里边的方法
      setSelectItem(val) {
        this.defaultCheckedKeys = val
        this.showDialogFlag = false;
      },
      clear(type) {
      },
      init() {
        if (this.id) {
          methodGet(getInfoByIdUrl + `${this.id}`).then(res => {
            this.ruleForm = res.data
            this.defaultMenuCheckedKeys = res.data.menuIds
          })
        }
        this.getMenuData()
        // this.getOrganizeData()
      },
      // 关闭弹框
      cancel() {
        this.showDialogFlag = false;
      },
      // 显示弹框
      showDialog(e, val) {
        this.showDialogFlag = true;
      }
    },
    mounted() {
    },
    created() {
      var userAgent = navigator.userAgent
      var isFirefox = userAgent.indexOf('Firefox') > -1
      if (isFirefox) {
        this.isFirefox = true;
      }
      this.init()
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
  .role-setting{
    flex:1;
    display: flex;
    .left-menu{
      position:relative;
      width: 30%;
      border:solid 1px #f3f3f3;
      overflow:hidden;
      padding:20px;
      box-sizing: border-box;
      display: flex;
    }
    .right-form{
      width:60%;
      padding-left: 20px;
      box-sizing: border-box;
      .title{
        margin-top: 10px;
        margin-bottom: 10px;
        font-size:16px;
        font-weight:normal;
      }
      .sub-title{
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
    .no-b-b {
      box-shadow: none;
      border: none;
    }
  }
.search-check-tree{
  padding-right:10%;
  overflow-y:scroll;
}
.isFirefox .search-check-tree{
  position:absolute;
  top:10px;
  left:10px;
  right:0px;
  bottom:0px;
  overflow-y:scroll;
}

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/roleSetting/index.vue